import React from 'react';
import Tooltip from '../tooltip/Tooltip';

import { STATUS_COLOR_CODES } from '@constants/common/miscellaneous';

const Circle = ({ id, content }) => {
    return (
        <div style={{ backgroundColor: STATUS_COLOR_CODES[(content)] || 'grey' }} className='tooltip--circle'>
            <Tooltip
                id=""
                empty={true}
                content={content}
                plain={true}
                index={`ticket-mgmt_desc_tooltip_${id}`}
                triggerDecorationClassName='tooltip--plain'
            />
        </div>
    );
};

export default Circle;